// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUndergroundItemPresenterSchema {
  /** ID линии метро на ЦИАНе **/
  cianId?: number;
  /** Полный заголовок **/
  fullName?: string;
  /** Гео тип адресного элемента **/
  geoType?: EGeoType;
  /** ID метро **/
  id?: number;
  /** Основная станция метро **/
  isDefault?: boolean;
  /** Цвет линии метро, hex **/
  lineColor?: string;
  /** ID линии метро **/
  lineId?: number;
  /** Название **/
  name?: string;
  /** Кверистринг для гео элемента **/
  qs?: string;
  /** Год постройки метро для строящейся станции **/
  releaseYear?: number;
  /** Сокращенный заголовок **/
  shortName?: string;
  /** Время в пути в минутах до метро, мин **/
  time?: number;
  /** Заголовок **/
  title?: string;
  /** Способ передвижения до метро **/
  transportType?: ETransportType;
  /** Тип сущности **/
  type?: EType;
  /** Является ли станция метро строящейся **/
  underConstruction?: boolean;
}
export enum EGeoType {
  /** Страна **/
  'Country' = 'country',
  /** Район **/
  'District' = 'district',
  /** Дом **/
  'House' = 'house',
  /** Местоположение **/
  'Location' = 'location',
  /** ЖД **/
  'Railway' = 'railway',
  /** Шоссе **/
  'Road' = 'road',
  /** Улица **/
  'Street' = 'street',
  /** Метро **/
  'Underground' = 'underground',
}
export enum ETransportType {
  /** На транспорте **/
  'Transport' = 'transport',
  /** Пешком **/
  'Walk' = 'walk',
}
export enum EType {
  /** Страна **/
  'Country' = 'country',
  /** Район **/
  'District' = 'district',
  /** Дом **/
  'House' = 'house',
  /** Местоположение **/
  'Location' = 'location',
  /** Метро **/
  'Metro' = 'metro',
  /** ЖД **/
  'Railway' = 'railway',
  /** Шоссе **/
  'Road' = 'road',
  /** Улица **/
  'Street' = 'street',
  /** Метро **/
  'Underground' = 'underground',
}
